import { catchWithAlert, handleResult } from 'as-ui-kit/utils/http';


const undefinedError = 'Что-то пошло не так. Попробуйте повторить запрос позже';

export const catchWithMsg = err => {
    if (err && (err.status >= 500 || !err.reason || err.error_code === 'unknown_server_error')){
        err.reason = undefinedError;
    }

    catchWithAlert(err);
};


export const handlePayFromVirtualResult = (response) => {
    if (response.status === 200) {
        window.location.assign('/active-truckers/');
        return;
    }
    return handleResult(response);
};

export const handlePayByCardResult = (response) => {
    if (response.status === 200) {
        response.json().then(redirectUrl => window.location.href = redirectUrl);
        return;
    }
    return handleResult(response);
};

export const goLogin = (isAtiApp) => {
    const loginFunc = window.openLoginPopup;
    if (isAtiApp || typeof loginFunc !== 'function') {
        const location = window.location;
        const mainDomain = window.atiEnv.baseDomain;

        if (!mainDomain || !location) {
            throw new Error('Домен не определен');
        }

        window.location = `//id.${mainDomain}/login?next=${encodeURIComponent(location.href)}`;
    } else {
        loginFunc();
    }
};

export const goToBilling = (price) => {
    const location = window?.location;
    const mainDomain = window.atiEnv.baseDomain;

    if (!mainDomain || !location) {
        throw new Error('Домен не определен');
    }

    window.location = `//billing.${mainDomain}/addInvoice?option=4&atis=${price}`;
};
